import React, { useEffect, useState } from "react";
import { errorMsg, successMsg } from "../../Toastify";
import { useSelector } from "react-redux";
import {
  CreateMessageMaster,
  GetMsessageList,
  UpdateMessageMaster,
} from "../../../Repository/Api";
import CustomModal from "../../CustomModal";
import { NonEmptyValidation, NumberValidation } from "../../../Store/validate";
const itemsPerPage = 10;

const Responsemessage = () => {
          const { first_name, desingation, access_token } = useSelector((state) => state?.auth?.auth);
  const token = access_token

  const [message, setMessage] = useState([]);
  const [masterModel, setMasterModel] = useState(false);
  const [createMessage, setCreateMessage] = useState({});
  const [validation, setValidation] = useState({});
  const [currentPage, setCurrentPage] = useState(1);

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = message.slice(indexOfFirstItem, indexOfLastItem);
  const [dummyleaveList, setdummyLeaveList] = useState([]);

  const [searchText, setSearchText] = useState('')
  

  const SearchfilteredData = dummyleaveList?.filter(item =>
    Object.values(item).some(value =>
      value?.toString().toLowerCase().includes(searchText.toLowerCase())
    )
  );
  useEffect(() => {
    if (searchText) {
      setMessage(SearchfilteredData)
      setCurrentPage(1)
    } else {
      setMessage(dummyleaveList)
    }
  }, [searchText, dummyleaveList])

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  useEffect(() => {
    getMessageList();
  },[]);

  const getMessageList = async () => {
    const response = await GetMsessageList(token);
    if (response && response.statusCode === 200) {
      // setMessage(response?.data?.response_message);
      setdummyLeaveList(response?.data?.response_message)
    } else {
      errorMsg(response.message);
    }
  };

  const setData = (e, key) => {
    let TempData = createMessage;
    TempData[key] = e;
    setCreateMessage(TempData);
    if (validation[key]) setValidation({ ...validation, [key]: false });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    let validate = {};
    validate.message_code = NumberValidation(createMessage?.message_code);
    validate.message = NonEmptyValidation(createMessage?.message);
    setValidation(validate);

    if (Object.values(validate).every((v) => v.status === true)) {
      const Payload = {
        message_code: createMessage.message_code,
        message: createMessage.message,
      };

      const response = await CreateMessageMaster(Payload, token);
      if (response && response.statusCode === 200) {
        successMsg(response.message);
        setCreateMessage({});
        setMasterModel(false);
        e.target.reset();
        getMessageList();
      } else {
        errorMsg(response.message);
      }
    }
  };

  const handleUpdate = async (e) => {
    e.preventDefault();

    let validate = {};
    validate.message_code = NumberValidation(createMessage?.message_code);
    validate.message = NonEmptyValidation(createMessage?.message);
    setValidation(validate);

    if (Object.values(validate).every((v) => v.status === true)) {
      const Payload = {
        message_code: createMessage.message_code,
        message: createMessage.message,
      };
      const response = await UpdateMessageMaster(Payload, token);
      if (response && response.statusCode === 200) {
        successMsg(response.message);
        setCreateMessage({});
        setMasterModel(false);
        e.target.reset();
        getMessageList();
      } else {
        errorMsg(response.message);
      }
    }
  };

  return (
    <>
      <div>
        <div className="row justify-content-center mt-3">
          <div className="col-lg-6">
            <div class="input-group flex-nowrap">
              <span class="input-group-text" id="addon-wrapping"><span class="material-symbols-outlined search-input-icon">search</span></span>
              <input type="text" class="form-control search-table-data"
                placeholder="Search"
                aria-describedby="addon-wrapping"
                name="search"
                value={searchText}
                onChange={(e) => setSearchText(e.target.value)}
              />
            </div>
          </div>
          <button
            type="button"
            className="btn add-btn add-btn col-lg-2"
            onClick={() => setMasterModel(true)}
          >
            <span className="material-symbols-outlined align-middle iconsize">
              add_circle
            </span>
            <span className="align-middle"> Add</span>
          </button>

        </div>

        <div className="graphbox">
          <table className="table table-hover">
            <thead>
              <tr>
                <th scope="col">S.No</th>
                <th scope="col">Message Name</th>
                <th scope="col">Message Code</th>
              </tr>
            </thead>
            <tbody>
              {currentItems.length > 0 ? (
                currentItems &&
                currentItems.map((mess, index) => (
                  <tr key={index}>
                    <td>{index + 1}</td>
                    <td
                      className="namelink textformat"
                      onClick={() => {
                        setMasterModel(true);
                        setCreateMessage(mess);
                      }}
                    >
                      {mess?.message}
                    </td>
                    <td>{mess?.message_code}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td></td>
                  <td>
                    <div> No Data Found </div>
                  </td>
                </tr>
              )}
            </tbody>
            <tfoot>
              <tr>
                <td colSpan="4">
                  {/* <nav aria-label="...">
                    <ul className="pagination">
                      <li
                        className={`page-item ${currentPage === 1 ? "disabled" : ""
                          }`}
                      >
                        <button
                          className="page-link"
                          onClick={() => paginate(currentPage - 1)}
                        >
                          Previous
                        </button>
                      </li>
                      {Array.from({
                        length: Math.ceil(message.length / itemsPerPage),
                      }).map((_, index) => (
                        <li
                          key={index}
                          className={`page-item ${currentPage === index + 1 ? "active" : ""
                            }`}
                        >
                          <button
                            className="page-link"
                            onClick={() => paginate(index + 1)}
                          >
                            {index + 1}
                          </button>
                        </li>
                      ))}
                      <li
                        className={`page-item ${currentPage ===
                            Math.ceil(message.length / itemsPerPage)
                            ? "disabled"
                            : ""
                          }`}
                      >
                        <button
                          className="page-link"
                          onClick={() => paginate(currentPage + 1)}
                        >
                          Next
                        </button>
                      </li>
                    </ul>
                  </nav> */}
                  <nav aria-label="...">
                    <ul className="pagination">
                      <li
                        className={`page-item ${currentPage === 1 ? "disabled" : ""}`}
                      >
                        <button
                          className="page-link"
                          onClick={() => paginate(currentPage - 1)}
                        >
                          Previous
                        </button>
                      </li>
                      {Array.from({
                        length: Math.ceil(message.length / itemsPerPage),
                      }).map((_, index) => {
                        if (
                          index + 1 >= currentPage - 4 && // Display 4 pages before current page
                          index + 1 <= currentPage + 5 // Display 5 pages after current page
                        ) {
                          return (
                            <li
                              key={index}
                              className={`page-item ${currentPage === index + 1 ? "active" : ""}`}
                            >
                              <button
                                className="page-link"
                                onClick={() => paginate(index + 1)}
                              >
                                {index + 1}
                              </button>
                            </li>
                          );
                        }
                        return null; // Hide pages outside the range
                      })}
                      <li
                        className={`page-item ${currentPage === Math.ceil(message.length / itemsPerPage) ? "disabled" : ""}`}
                      >
                        <button
                          className="page-link"
                          onClick={() => paginate(currentPage + 1)}
                        >
                          Next
                        </button>
                      </li>
                    </ul>
                  </nav>
                </td>
              </tr>
            </tfoot>
          </table>
        </div>
      </div>

      {/* masterModel */}
      <CustomModal
        open={masterModel}
        onClickOutside={() => {
          setMasterModel(false);
          setCreateMessage({});
        }}
      >
        <form
          onSubmit={(e) => {
            if (createMessage.id) {
              handleUpdate(e);
            } else {
              handleSubmit(e);
            }
          }}
        >
          <div className="modal-content Modal-View m-auto">
            <div className="modalHeader text-center py-2">
              <h5 className="font-bold mt-2">
                {createMessage.id ? "Update" : "Add New"}
                &nbsp;Message Master
              </h5>
            </div>
            <div className="modal-body p-0 ">
              <div className="container">
                <div className="row d-flex align-items-center justify-content-center  mt-0">
                  <div className="container ">
                    <div className="row justify-content-center">
                      <div className="col-lg-8">
                        <div className="mb-3">
                          <label className="labeltext">Message Code:</label>
                          <input
                            type="text"
                            className="fieldinput"
                            placeholder="Enter Message Code"
                            defaultValue={createMessage?.message_code}
                            onChange={(e) => {
                              setData(e.target.value, "message_code");
                            }}
                          />
                          <small className="validationerror">
                            {validation?.message_code?.message
                              ? `Message Code ${validation?.message_code?.message}`
                              : ""}
                          </small>
                        </div>
                        <div className="mb-3">
                          <label className="labeltext">
                            Name of the Message:
                          </label>
                          <textarea
                            type="text"
                            className="fieldinput"
                            placeholder="Enter Message"
                            defaultValue={createMessage?.message}
                            onChange={(e) => {
                              setData(e.target.value, "message");
                            }}
                          />
                          <small className="validationerror">
                            {validation?.message?.message
                              ? `Message ${validation?.message?.message}`
                              : ""}
                          </small>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="modal-footer border-0">
              <div>
                <button
                  type="button"
                  className="btn mx-2 submit-btn"
                  onClick={() => {
                    setMasterModel(false);
                    setValidation({});
                    setCreateMessage({});
                  }}
                >
                  Back
                </button>
              </div>
              <div>
                <button className="btn mx-2 submit-btn">
                  {createMessage.id ? "Update" : "Create"}
                </button>
              </div>
            </div>
          </div>
        </form>
      </CustomModal>
    </>
  );
};

export default Responsemessage;
